<app-modal-template
  [title]="data.title"
  [hasCloseButton]="true"
  [size]="PencilModalSizeEnum.LARGE"
  (closeButtonClicked)="onCancel()"
>
  <div content-description class="slides-checking-access-dialog__body">
    <div class="slides-checking-access-dialog__spinner-wrapper">
      <app-pencil-spinner [diameter]="45" [strokeWidth]="6"></app-pencil-spinner>
    </div>
    <p class="slides-checking-access-dialog__message">
      {{ data.message }}
    </p>
  </div>
</app-modal-template>
